import { toast } from "sonner";
import { useReplaceFile } from "../../../lib/fileQueries";

/**
 * Master v5 Prompt 11 — shared "Replace" trigger. A replacement always
 * creates a NEW FileAssetVersion; the prior version/every link stays
 * untouched underneath (file_repository.create_replacement_version).
 */
export default function ReplaceFileInline({ workspaceId, entry, onDone }) {
  const replace = useReplaceFile(workspaceId, entry.asset.fas_id);
  return (
    <input
      type="file"
      autoFocus
      data-testid="file-replace-input"
      style={{ position: "fixed", top: -9999, left: -9999 }}
      ref={(el) => el && el.click()}
      onChange={async (e) => {
        const file = e.target.files?.[0];
        if (!file) return onDone();
        try {
          await replace.mutateAsync({ file });
          toast.success("Replaced — the previous version is preserved in history.");
        } catch (err) {
          toast.error(err.body?.detail || "Replace failed");
        }
        onDone();
      }}
    />
  );
}
